import React from 'react';
import { useDispatch } from 'react-redux';
import Card from "../Card/Card";
import SkynetForm from "../Fundamentals/Form/SkynetForm";
import {FormInput, InputType} from "../FormComponents/Input/Input";
import {RadioButtons} from "../FormComponents/RadioButtons";
import {Button} from "../Fundamentals/Button";
import formActions from "../../Actions/formActions";
import {Checkbox} from "../FormComponents/Checkbox";

function GdprRequestForm({ form, onSubmit }) {
    const dispatch = useDispatch();
    
    const items = [
        {label: 'Customer number', value: 'custNo'},
        {label: 'Email', value: 'email'}
    ];

    const handleFieldChange = (field) => (value) => {
        dispatch(formActions.changeMultiFormField(form, field, value));
    };

    return (
        <Card>
            <Card.Header>
                <Card.Header.Title>Request</Card.Header.Title>
            </Card.Header>
            <Card.Content>
                <div>
                    <SkynetForm>
                        <SkynetForm.FieldSet legend={"Configuration"}>
                            <SkynetForm.FieldSet.FormGroup>
                                <RadioButtons 
                                    label={"Clean by"} 
                                    items={items} 
                                    onChange={handleFieldChange('type')}
                                    value={form.data.type}
                                />
                                <FormInput 
                                    value={form.data.value} 
                                    label={form.data.type === 'custNo' ? "Customer Number" : "Email Address"} 
                                    type={form.data.type === 'custNo' ? InputType.NUMBER : InputType.EMAIL} 
                                    onChange={handleFieldChange('value')}
                                    errorText={form.fieldErrorFlags?.value}
                                />
                            </SkynetForm.FieldSet.FormGroup>
                            <SkynetForm.FieldSet.FormGroup>
                                <Checkbox 
                                    label="Dry run" 
                                    checked={form.data.isDryRun} 
                                    onChange={handleFieldChange('isDryRun')}
                                />
                            </SkynetForm.FieldSet.FormGroup>
                        </SkynetForm.FieldSet>
                    </SkynetForm>
                </div>
            </Card.Content>
            <Card.Footer>
                <Card.Footer.Buttons>
                    <Button onClick={onSubmit}>Request</Button>
                </Card.Footer.Buttons>
            </Card.Footer>
        </Card>
    );
}

export default GdprRequestForm;

